import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage2 = React.lazy(
  () => import('../../pages/stages/stage2/Stage2Main'),
)
const Stage2Story = React.lazy(
  () => import('../../pages/stages/stage2/Stage2Story'),
)
const Stage2Ending = React.lazy(
  () => import('../../pages/stages/stage2/Stage2Ending'),
)

const loc = `stage2`

export const Stage2Routes = (
  <>
    <Route
      path="/stage2"
      element={
        <RoutesWrapper loc={loc}>
          <Stage2 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage2/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage2Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage2/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage2Ending />
        </RoutesWrapper>
      }
    />
  </>
)
